var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero is-gray is-fullheight-with-navbar"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container has-text-centered"},[_c('h1',{staticClass:"title"},[_vm._v("¡Bienvenido a tu Panel de Administración!")]),_c('h2',{staticClass:"subtitle"},[_vm._v("Administra fácilmente tu perfil, interacciones y más.")])])])])
}]

export { render, staticRenderFns }